import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ProductsListQuery, ProductsListResponse } from '../types/product';

function buildQueryString(q: ProductsListQuery & { cursor?: string }): string {
  const params = new URLSearchParams();
  if (q.status) params.set('status', q.status);
  if (q.search) params.set('search', q.search);
  if (q.tags?.length) params.set('tags', q.tags.join(','));
  if (q.sort) params.set('sort', q.sort);
  if (q.order) params.set('order', q.order);
  if (q.limit) params.set('limit', String(q.limit));
  if (q.cursor) params.set('cursor', q.cursor);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export function useProducts(filters: ProductsListQuery) {
  return useInfiniteQuery({
    queryKey: ['products', filters],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) =>
      api<ProductsListResponse>(
        `/products${buildQueryString({ ...filters, cursor: pageParam })}`,
      ),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
